export const removeSubstring = (str: string, substrings: string[]): string => {
  for (const sub of substrings) {
    if (str.includes(sub)) {
      return str.replace(sub, '')
    }
  }
  return str
}
